module.exports = __webpack_public_path__ + "img/pers-appartement-interieurs.920916b4.jpg";